import { FC, useState } from 'react';
import { Button, Checkbox } from 'antd';

interface StepThreeProps {
  previous: () => void;
  next: () => void;
}

const StepThree: FC<StepThreeProps> = ({ previous, next }) => {
  const [checkbox, setCheckbox] = useState(false);
  const [checkboxAlert, setCheckboxAlert] = useState(false);

  return (
    <div className="space-y-6">
      <h4 className="text-center text-2xl font-bold text-primary">
        Help us get to know your brand
      </h4>

      <div className="mx-auto min-w-[280px] max-w-[70%] text-center text-gray-500">
        <div className="mb-3">
          Answer a few quick questions about your business, competitors, and
          goals. We’ll use your insights to tailor everything to your brand.
        </div>

        <a
          href="https://forms.gle/QZcL4QyEM3QyEZXu9"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button type="primary" className="mb-3">
            Complete the quick form
          </Button>
        </a>
      </div>

      <div className="flex items-center justify-center">
        <Checkbox onChange={(event) => setCheckbox(event.target.checked)}>
          <span className={checkboxAlert ? 'text-red-500' : 'text-primary'}>
            I’ve completed the form
          </span>
        </Checkbox>
      </div>

      <div className="flex items-center justify-between gap-4">
        <Button onClick={() => previous()}>Back</Button>

        <Button
          type="primary"
          onClick={() => {
            if (checkbox) {
              next();
              return;
            }
            setCheckboxAlert(true);
          }}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};

export default StepThree;
